//* ------------------------------------*\
//    $MISC STRINGS
//* -----------------------------------*/

const MISC = {
  ALL: 'all',
  BEFOREEND: 'beforeend',
  BEM_ELEMENT: '__',
  BEM_MODIFIER: '--',
  BV_CURSOR_X: '--bv-cursor-x',
  BV_CURSOR_Y: '--bv-cursor-y',
  CHANGE: 'Change ',
  CLEAR_FILTER: 'Clear Filter',
  CLOSE: 'Close',
  CLOSE_FILTERS: 'Close Filters',
  DATA_VISIBLE: 'data-visible',
  EYE_BLINK: 'EyeBlink',
  FALSE: 'false',
  FILTERS: 'Filters',
  FINE_POINTER: '(hover: hover) and (pointer: fine)',
  FLOATING_NAV_HEIGHT: '--floating-nav-height',
  fURL1: '//www.facebook.com/sharer.php?u=',
  HEADER_OFFSET: 80,
  HEIGHT: 'height',
  IN_VIEWPORT: 'in-viewport',
  MENU: 'Menu',
  MQ_HOVER: '(hover: hover)',
  MQ_NO_ANY: '(any-hover: none), (any-pointer: coarse)',
  lURL1: '//www.linkedin.com/shareArticle?mini=true&url=',
  lURL2: '&title=',
  lURL3: '&summary=',
  lURL4: '&source=',
  mURL1: 'mailto:',
  mURL2: '?subject=',
  mURL3: '&body=',
  NAME: 'name',
  NO: 'no',
  NO_RESULTS: 'There are no posts that match that filter combination.',
  POST: 'post',
  POSTS: 'posts',
  PUBLISH: 'publish',
  SQUERY: '&s=',
  SMOOTH: 'smooth',
  TABINDEX: 'tabindex',
  TRUE: 'true',
  tURL1: 'https://twitter.com/share?url=',
  tURLText: '&text=',
  tURLVia: '&via=BSD',
  VALUE: 'value',
  WIDTH: 'width'
};

export default MISC;
